/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, List, ListItem, ListItemAvatar, ListItemText, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { styles } from "../../../theme";
import AppScreenLoader from "../../../../../components/AppScreenLoader";
import { getCurrencyListFiat, getMassPayPaymentMethods, logEvent} from "../../../../../store/api";
import { addSkipIndex, removeSkipIndex } from "../../../../../store/actions";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { ACTIVITY_DETAIL, EVENTS } from "../../../../../utils/constants";

export default function PaymentOptionSelect({ amount, active, setActive, country, paymentMethod, setPaymentMethod, setPaymentCurrency,
    setDestinationId }) {
    const [methods, setMethods] = useState([]);
    const dispatch = useDispatch();
   const location = useLocation();
    useEffect(() => {
        fetchMethods();
    }, [])
    const fetchMethods = async () => {
        const response = await getMassPayPaymentMethods(country.three_letter_code);
        if (response.result.length === 1) {
            setPaymentMethod(response.result[0]);
        }
        setMethods(response.result)
    }
    const handlePaymentMethod = async (method) => {
        logEvent({
            current: EVENTS.WITHDRAWAL.FIAT_METHOD,
            activity: ACTIVITY_DETAIL.WITHDRAWAL.FIAT_METHOD,
            meta: {
                data: {
                    methodName:method.displayName,
                    pathname: location.pathname,
                    source: ACTIVITY_DETAIL.WITHDRAWAL.FIAT_METHOD
                }
            }
        });
        setPaymentMethod(method);

        const currenciesResponse = await getCurrencyListFiat(amount, country.three_letter_code, paymentMethod.actualValue);
        if (currenciesResponse.result.currencySymbols.length === 1) {
            setPaymentCurrency(currenciesResponse.result.currencySymbols[0]);
            setDestinationId(currenciesResponse.result.destinationRecordId);
            dispatch(addSkipIndex(active + 1));
            setActive(active + 2);
        } else {
            dispatch(removeSkipIndex(active + 2))
            setActive(active + 1);
        }
    }
    const GetIcon = ({ icon }) => {
        try {
            const Logo = require(`../../../../../assets/logo/bank_deposit.svg`).default;
            return <Logo />
        } catch (err) {
            return ""
        }
    }
    if (!methods || !methods.length) {
        return <AppScreenLoader />
    }
    return (<Paper
        sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: 1,
        }}
    >
        <List>
            {methods.map((value, index) => (
                <ListItem
                    key={index}
                    style={value?.displayName === paymentMethod?.displayName ? styles.selected : {}}
                    onClick={(ev) => handlePaymentMethod(value)}
                >
                    <ListItemAvatar>
                        <Avatar>
                            <GetIcon icon={value.actualValue.toLowerCase()} />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={`${value.displayName}`} />
                </ListItem>
            ))}
        </List>
    </Paper>)
}